import React from "react"
import { formatMoney, formatDateTime } from "../transactions/format"
import { StatusPill } from "./StatusPill"
import { MerchantLabel } from "../shared/MerchantLabel"
import { DevStoreBadge } from "../shared/DevStoreBadge"

// Responsive merchant list: a real table on md+ (sticky header), stacked cards
// on small screens. Each row links to the merchant detail. Mirrors
// TransactionsTable's responsive pattern (doc 09 table→cards on sm).
export function CustomersTable({ rows, detailBasePath, copy }) {
  const href = (id) => `${detailBasePath}/${id}`

  return (
    <>
      {/* Desktop / tablet table */}
      <div className="hidden overflow-x-auto rounded-xl border border-gray-200 dark:border-gray-800 md:block">
        <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-800 text-sm">
          <thead className="sticky top-0 bg-gray-50 dark:bg-gray-800/50">
            <tr className="text-left text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400">
              <th className="px-4 py-3">{copy.columns.shop}</th>
              <th className="px-4 py-3">{copy.columns.app}</th>
              <th className="px-4 py-3">{copy.columns.plan}</th>
              <th className="px-4 py-3">{copy.columns.status}</th>
              <th className="px-4 py-3 text-right">{copy.columns.lifetime}</th>
              <th className="px-4 py-3">{copy.columns.installedAt}</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100 dark:divide-gray-800 bg-white dark:bg-gray-900">
            {rows.map((r) => (
              <tr key={r.id} className="cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-800" onClick={() => { window.location.href = href(r.id) }}>
                <td className="px-4 py-3 font-medium text-gray-900 dark:text-gray-100">
                  <a href={href(r.id)} className="block hover:underline" onClick={(e) => e.stopPropagation()}>
                    <MerchantLabel
                      name={r.name}
                      shop={r.shop}
                      primaryClassName="truncate text-sm font-medium text-brand-700 dark:text-brand-300"
                    />
                  </a>
                </td>
                <td className="px-4 py-3 text-gray-700 dark:text-gray-300">{r.app || "—"}</td>
                <td className="px-4 py-3 text-gray-700 dark:text-gray-300">{r.current_plan || "—"}</td>
                <td className="px-4 py-3">
                  <div className="flex flex-wrap items-center gap-1.5">
                    <StatusPill status={r.status} copy={copy} />
                    {r.is_development_store && <DevStoreBadge label={copy.devStore.badge} />}
                  </div>
                </td>
                <td className="px-4 py-3 text-right tabular-nums text-gray-900 dark:text-gray-100">{formatMoney(r.lifetime_net_cents, "USD")}</td>
                <td className="px-4 py-3 whitespace-nowrap text-gray-500 dark:text-gray-400">{formatDateTime(r.first_installed_at)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Mobile cards */}
      <div className="space-y-3 md:hidden">
        {rows.map((r) => (
          <a
            key={r.id}
            href={href(r.id)}
            className="block rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 p-4"
          >
            <div className="flex items-start justify-between">
              <div className="min-w-0">
                <MerchantLabel name={r.name} shop={r.shop} primaryClassName="truncate text-sm font-medium text-gray-900 dark:text-gray-100" />
                <div className="text-xs text-gray-500 dark:text-gray-400">{r.app || "—"}</div>
              </div>
              <div className="flex flex-col items-end gap-1">
                <StatusPill status={r.status} copy={copy} />
                {r.is_development_store && <DevStoreBadge label={copy.devStore.badge} />}
              </div>
            </div>
            <dl className="mt-3 grid grid-cols-2 gap-y-1 text-xs text-gray-600 dark:text-gray-400">
              <dt className="text-gray-400 dark:text-gray-500">{copy.columns.plan}</dt>
              <dd className="text-right">{r.current_plan || "—"}</dd>
              <dt className="text-gray-400 dark:text-gray-500">{copy.columns.lifetime}</dt>
              <dd className="text-right tabular-nums">{formatMoney(r.lifetime_net_cents, "USD")}</dd>
              <dt className="text-gray-400 dark:text-gray-500">{copy.columns.installedAt}</dt>
              <dd className="text-right">{formatDateTime(r.first_installed_at)}</dd>
            </dl>
          </a>
        ))}
      </div>
    </>
  )
}
